// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy-policy-module__container___10FKk","breadcrumb":"privacy-policy-module__breadcrumb___184Bf"};